import React from "react";
import Stack from "@mui/material/Stack";
import DashboardSafeReminders from "../web/widgets/DashboardSafeReminders";
import DashboardSafeLinks from "../web/widgets/DashboardSafeLinks";
import DashboardSafeGuides from "../web/widgets/DashboardSafeGuides";

export default function MobileDashboardSafeCards() {
    return (
        <Stack spacing={2}>
            <DashboardSafeReminders />
            <DashboardSafeLinks />
            <DashboardSafeGuides />
        </Stack>
    );
}
